import { Component } from '@angular/core';

interface FeatureItem {
    icon: string;
    title: string;
    description: string;
}

@Component({
    selector: 'app-why-althea-redesign',
    templateUrl: './why-althea-redesign.component.html',
    styleUrls: ['./why-althea-redesign.component.scss']
})
export class WhyAltheaRedesignComponent {

    title = 'Why Althea Soft';

    subtitle = 'Our approach combines:';

    description =
        'Althea Soft is not a wellness application or a generic digital health tool. It is a clinical AI platform designed for complex healthcare environments.';

    image = '/assets/img/redesign/about/team.png';

    imageAlt = 'Why Althea Soft';

    footer =
        'This focus matters because mental healthcare decisions carry clinical, legal, operational and reputational responsibility.';

    items: FeatureItem[] = [
        {
            icon: '/assets/img/redesign/about/icon-1.png',
            title: 'Clinical AI and predictive analytics',
            description: 'to support earlier risk detection.'
        },
        {
            icon: '/assets/img/redesign/about/icon-2.png',
            title: 'Real-time monitoring',
            description: 'through patient data, biometric signals and digital inputs.'
        },
        {
            icon: '/assets/img/redesign/about/icon-3.png',
            title: 'Multidisciplinary coordination',
            description: 'connecting clinical teams and departments.'
        },
        {
            icon: '/assets/img/redesign/about/icon-4.png',
            title: 'Institutional deployment',
            description: 'for hospitals, clinics, public health systems and healthcare organisations.'
        }
    ];

    trackByTitle(index: number, item: FeatureItem): string {
        return item.title;
    }

}